
<div class="btn-group">
  <button class="btn btn-sm btn-outline-primary" (click)="move(-1)"><span class="oi oi-arrow-top"></span></button>
  <button class="btn btn-sm btn-outline-primary" (click)="move(1)"><span class="oi oi-arrow-bottom"></span></button>
</div>